export default {
    fonts: {
        SSProRegular: "font-family: 'Source Sans Pro', sans-serif; font-weight: 400;",
        SSProSemiBold: "font-family: 'Source Sans Pro', sans-serif; font-weight: 600;",
        RobotoRegular: "font-family: 'Roboto', sans-serif; font-weight: 400;",
        SpectralBold: "font-family: 'Spectral', serif; font-weight: 700;",
    },
    colors: {
        black: '#333333',
        main: '#002857',
        blue: '#2472b9',//'#006CEF',
        brightBlue: '#006CEF',
        darkBlue: '#013871',
        gray: '#AAAAAA',
        red: '#FF4136',
        brown: '#B64944',
        lightBrown: '#D3928F',
        lighterBrown: '#E2B6B4',
        pink: '#F0DBDA',
        darkPink: '#D4ACAA',
    },
    animations: {
    
    },
    mixins: {
        columns: (cols = 3, gap = '40px') => {
            return `
                width: calc((100% - ((${cols} - 1) * ${gap})) / ${cols});
                margin-bottom: ${gap}; 
                &:nth-child(n) {
                    margin-right: ${gap};
                }
                &:nth-child(${cols}n) {
                    margin-right:0;
                }
                `;
        },
        fluidType: (minSize = 16, maxSize = 40, minScreen = 320, maxScreen = 1260) => {
            return `
                font-size: ${minSize}px;
                @media (min-width: ${minScreen}px) {
                    font-size: calc(${minSize}px + (${maxSize} - ${minSize}) * ((100vw - ${minScreen}px) / (${maxScreen} - ${minScreen})));
                }
                @media (min-width: ${maxScreen}px) {
                    font-size: ${maxSize}px;
                }
            `
        }
    }
} 


// WEBPACK FOOTER //
// ./src/css/index.js